import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { carModel, motorModel, travelModel,accidentModel,petModel,vaccineModel } from '@/utils/asyncValidator/queryForms';

const state = {
  queryInfo: {
    model: null,
    tips: null
  },
  selectedInsus: [],
  loading: false,
  products: null,
  modal: null,
};

export default {
  state,
  getters,
  mutations,
  actions
};